export default () => {

  'ngInject';

  return {
    restrict: 'A',
    require: 'ngModel',
    link: ($scope, $element, $attrs, $ctrl) => {

      const maxValidator = value => {
        const max = parseInt($scope.vuiMax);
        if (value && parseInt(value) > max) {
          $ctrl.$setValidity('vuiMax', false);
          return undefined;
        } else {
          $ctrl.$setValidity('vuiMax', true);
          return value;
        }
      };

      $ctrl.$parsers.push(maxValidator);
      $ctrl.$formatters.push(maxValidator);

    }
  };
}
